import {PAYMENT_METHODS} from "@/modules/delivery/constants/OrderPayment";
import BaseOrderService from "@/modules/delivery/core/services/BaseOrderService";


class PaymentService extends BaseOrderService{
    constructor(order, settings, categoryService) {
        super(order, settings, categoryService);

    }

    get isReady(){
        if (this.order.payment.method) {
            return true
        }
        return false
    }



    setMethod(value){
        if(value && !PAYMENT_METHODS.includes(value)){
            throw new Error('Invalid payment method. Must be one of the following: '+ PAYMENT_METHODS.join(','));
        }
        this.order.payment.method = value;
    }

    setReceiptFile(receiptFile){
        this.order.payment.receiptFile = receiptFile;
    }

    setConfirmed(confirmed){
        this.order.payment.confirmed = confirmed;
    }
}

export default PaymentService;
